"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IUpNextItemType = void 0;
var IUpNextItemType;
(function (IUpNextItemType) {
    IUpNextItemType["ContinueChallengeWorkout"] = "continue-challenge-workout";
    IUpNextItemType["ContinueSeriesWorkout"] = "continue-series-workout";
    IUpNextItemType["LiveScheduledWorkout"] = "live-scheduled-workout";
    IUpNextItemType["RecommendedWorkout"] = "recommended-workout";
    IUpNextItemType["ScheduledWorkout"] = "scheduled-workout";
    IUpNextItemType["StaffPickWorkout"] = "staff-pick-workout";
})(IUpNextItemType || (exports.IUpNextItemType = IUpNextItemType = {}));
//# sourceMappingURL=up-next-item-type.js.map